var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-choose-selected h-screen ios-touch-scroll"},[_c('CatChooseSelected',{attrs:{"data-list":_vm.dataList,"read-only":_vm.readOnly}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }